import React from 'react';
import Layout from '../../../components/Layout';
import Reveal, { SplitWords } from '../../../components/Reveal';

/**
 * @author Nelson
 */
const PrivacyPolicy = () => (
    <Layout title="Privacy Policy">
        <header className="page__head">
            <h1 className="page__eyebrow reveal" style={{ '--reveal-delay': '80ms' }}>
                Privacy Policy
            </h1>
            <h2 className="page__title page__title--display">
                <SplitWords text="Your Privacy Matters" start={200} />
            </h2>
        </header>

        <div className="prose">
            <Reveal as="p" delay={460}>
                At YUAN Lab Enterprise, your privacy is our top priority. This Privacy Policy explains what information we collect, how we use it, and your choices regarding your information.
            </Reveal>

            <Reveal as="h3" delay={40}>Information We Collect</Reveal>
            <Reveal as="ul" delay={80}>
                <li>Personal Information: Such as email address when you contact us for support.</li>
                <li>App Usage Data: Anonymous usage data to help improve our app experience.</li>
                <li>No Sensitive Data: We do not collect sensitive personal data or financial information.</li>
            </Reveal>

            <Reveal as="h3" delay={40}>How We Use Your Information</Reveal>
            <Reveal as="ul" delay={80}>
                <li>To provide, maintain, and improve our apps.</li>
                <li>To respond to your inquiries and provide support.</li>
                <li>To analyze anonymized usage trends for product improvement.</li>
            </Reveal>

            <Reveal as="h3" delay={40}>Data Sharing</Reveal>
            <Reveal as="p" delay={80}>
                We do not sell your personal information. We only share information with trusted partners for app functionality (e.g., analytics, crash reporting) and legal compliance.
            </Reveal>

            <Reveal as="h3" delay={40}>Your Choices</Reveal>
            <Reveal as="p" delay={80}>
                You may request access or deletion of your data by contacting us at <a className="u-link" href="mailto:customersupport@appancestor.com">customersupport@appancestor.com</a>.
            </Reveal>

            <Reveal as="h3" delay={40}>Updates</Reveal>
            <Reveal as="p" delay={80}>
                We may update this policy from time to time. Please check this page for the latest version.
            </Reveal>

            <Reveal as="h3" delay={40}>Contact</Reveal>
            <Reveal as="p" delay={80}>
                If you have questions or concerns, please email us: <a className="u-link" href="mailto:customersupport@appancestor.com">customersupport@appancestor.com</a>
            </Reveal>
        </div>
    </Layout>
);

export default PrivacyPolicy;
